<template lang="pug">
.match-bet-area-type
  .match-bet-area-type-title {{ betType == 'oxt' ? $tc("m.BT_1X2F", 2) : $tc("m.BT_1X2H", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Home") }}
      p.mb-0 {{ $t("m.ODD_Away") }}
      p.mb-0 {{ $t("m.ODD_Draw") }}
    template(v-for="(dn, i) in details['kns']")
      .match-odd-area-group(v-if="i == 0")
        template(v-if="details[betType] && details[betType][i]")
          OddsItem(:odds="details[betType][i]" idx=5 :typ="oddsType" dataType="2" label="1" :details="details")
        template(v-else)
          OddsDisabled
        template(v-if="details[betType] && details[betType][i]")
          OddsItem(:odds="details[betType][i]" idx=7 :typ="oddsType" dataType="2" label="2" :details="details")
        template(v-else)
          OddsDisabled
        template(v-if="details[betType] && details[betType][i]")
          OddsItem(:odds="details[betType][i]" idx=6 :typ="oddsType" dataType="2" label="X" :details="details")
        template(v-else)
          OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    }
  }
};
</script>